import {
  Card,
  Divider,
  Flex,
  Heading,
  Text,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import useYellowhiveFlowProductsBasketStore from '@flows/src/store/zustand/flows-products/useYellowhiveFlowProductsBasketStore';

const YellowhiveFlowProductsSideBarBasketPriceSummary = () => {
  const { t } = useTranslation();
  const basketItems = useYellowhiveFlowProductsBasketStore(
    (state) => state.basketItems,
  );
  // Calculate totals by payment interval based on items in basket.
  const totalsByInterval: Record<string, number> = basketItems.reduce(
    (acc, item) => {
      const interval = item.payment_interval || 'ANNUAL';
      acc[interval] = (acc[interval] || 0) + (item.total_premium || 0);
      return acc;
    },
    {} as Record<string, number>,
  );

  if (basketItems.length === 0) {
    return null;
  }

  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format(price);
  };

  return (
    <Card
      mx="4"
      bg="gray.ultraLight"
      borderColor="gray.50"
      boxShadow="none"
      mt="4"
    >
      <Heading as="h3" size="md" mb="4">
        {t('FLOWS_PRODUCT-BASKET_PRICE-SUMMARY_TITLE')}
      </Heading>
      <VStack
        align="stretch"
        spacing="3"
        divider={<Divider borderColor="gray.200" />}
      >
        {Object.keys(totalsByInterval).map((interval) => (
          <Flex key={interval} justify="space-between">
            <Text textStyle="h6Headline">
              {Object.keys(totalsByInterval).length > 1
                ? `${t('PREMIUM')} ${t('Per').toLowerCase()} ${t(
                    interval,
                  ).toLowerCase()}`
                : t('TOTAL')}
              :
            </Text>
            <Text textStyle="h6Headline">
              {formatPrice(totalsByInterval[interval])}
            </Text>
          </Flex>
        ))}
      </VStack>
      <Text textStyle="smallBody" color="gray.500" mt="3">
        *{t('FLOWS_PRODUCT-BASKET_PRICE-SUMMARY_FOOTNOTE')}
      </Text>
    </Card>
  );
};

export default YellowhiveFlowProductsSideBarBasketPriceSummary;
